import { Injectable } from '@angular/core';
import { Observable, of, forkJoin } from 'rxjs';
import { map } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class VendorMappingService {
  constructor(private http: HttpClient) {}

  getPartVendorMappings(): Observable<any[]> {
    return forkJoin([
      this.http.get<any>('assets/mock/source_data.json'),
      this.http.get<any>('assets/mock/po_details.json')
    ]).pipe(
      map(([sourceData, poDetails]) => {
        return sourceData.sourceData.map(part => {
          const vendorsForPart = poDetails.poDetails
            .filter(po => po.parts.some(p => p.customerPartNo === part.customerPartNo))
            .map(po => ({
              name: po.supplier,
              isSelected: false,
              targetPrice: po.parts.find(p => p.customerPartNo === part.customerPartNo)?.targetPrice,
              currency: po.parts.find(p => p.customerPartNo === part.customerPartNo)?.currency,
              leadTime: po.parts.find(p => p.customerPartNo === part.customerPartNo)?.targetLeadTime
            }));

          return {
            ...part,
            vendors: vendorsForPart
          };
        });
      })
    );
  }

  saveVendorMappings(mappings: any[]): Observable<any> {    
    localStorage.setItem('vendorMappings', JSON.stringify(mappings));
    return of({ success: true });
  }
}
